var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"cardx"},[_c('div',{staticStyle:{"padding":"10px"},attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("\n      Orders\n    ")])]),_c('div',[_c('orders',{attrs:{"filters":_vm.filters}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }